<template>
  <b-card class="mb-3">
    <div class="d-flex justify-content-between mb-3" v-if="title">
      <h2 class="mb-0">Recently Added Resources</h2>

      <b-btn variant="secondary" size="sm" to="/admin/resources">
        View More
      </b-btn>
    </div>
    <div class="d-flex justify-content-end mx-2 mb-3">
      <b-btn variant="secondary" size="sm" @click="exportResources()">
        Export
      </b-btn>
    </div>

    <div class="table-responsive">
      <table class="table b-table">
        <thead>
          <tr>
            <th style="width: 120px;">Title</th>
            <th>Description</th>
            <th>Resource type</th>
            <th>Skills</th>
            <th>Owner</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="results.length === 0">
            <td class="text-center" colspan="7">
              <em>No resources found!</em>
            </td>
          </tr>

          <tr v-for="resource in results" :key="resource.uuid">
            <td>
              <router-link :to="`resources/${resource.uuid}/edit`">
                {{ resource.title }}
              </router-link>
            </td>
            <td>{{ resource.description }}</td>
            <td>{{ resource.item_type }}</td>
            <td>{{ skillsFormat(resource.skills) }}</td>
            <td>
              <router-link :to="`/user/${resource.owner.uuid}`">
                <img
                  class="rounded-circle img-profile mr-2"
                  :src="resource.owner.avatar"
                  :alt="
                    `${resource.owner.first_name} ${resource.owner.last_name}`
                  "
                />
                {{ resource.owner.first_name }} {{ resource.owner.last_name }}
              </router-link>
            </td>
            <td>
              <!-- Action button here, will need dynamic title -->
              <b-btn
                variant="primary"
                size="sm"
                @click="actionButtonTapped(resource)"
                class="mb-2"
                block
              >
                {{ actionText(resource.item_type) }}
              </b-btn>

              <b-btn
                variant="danger"
                size="sm"
                block
                @click="deleteModel(resource)"
              >
                Delete
              </b-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="d-flex justify-content-between align-items-center"
      v-if="pagination"
    >
      <b-btn
        variant="secondary"
        size="sm"
        @click="setPage(page - 1)"
        :disabled="loading || page === 1"
      >
        Prev Page
      </b-btn>

      <span class="text-muted" v-if="!loading">
        Page {{ page }} of {{ totalPages }}
      </span>

      <span class="text-muted" v-if="loading">
        Loading
      </span>

      <b-btn
        variant="secondary"
        size="sm"
        @click="setPage(page + 1)"
        :disabled="loading || page === totalPages"
      >
        Next Page
      </b-btn>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'EducationalItemsTable',
  props: {
    count: Number,
    pagination: Boolean,
    title: Boolean,
  },
  data() {
    return {
      loading: false,
      page: 1,
      totalPages: 0,
      results: [],
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true

      this.$http
        .get('/admin/resources?page=' + this.page + '&page_count=' + this.count)
        .then((res) => {
          this.results = res.data.data
          this.totalPages = res.data.meta.last_page
        })
        .finally(() => {
          this.loading = false
        })
    },
    setPage(page) {
      this.page = page
      this.load()
      window.scrollTo(0, 0)
    },
    deleteModel(resource) {
      if (!window.confirm('Are you sure you want to delete this resource?')) {
        return
      }
      this.loading = true

      this.$http
        .delete(`/admin/resources/${resource.uuid}`)
        .then(() => {
          this.load()
        })
        .finally(() => {
          this.loading = false
        })
    },
    skillsFormat(skills) {
      return skills.map((s) => s.title.split(' ')[0]).join(', ')
    },
    /**
     * Returns the text to be displayed in the action button
     */
    actionText(itemType) {
      switch (itemType) {
        case 'pdf':
        case 'ppt':
        case 'mp4':
        case 'xls':
          return 'Download'
        case 'youtube':
        case 'gdrive':
        case 'url':
          return 'Open'
        default:
          return ''
      }
    },
    /**
     * Currently, simply opens the url in a new window. In the future, will have more specific actions
     */
    actionButtonTapped(resource) {
      window.open(resource.url, '_blank')
    },
    exportResources() {
      if (this.loading) {
        return
      }

      this.loading = true
      this.$http.post(`/admin/resources/export`)
        .then(res => {
            var fileUrl = window.URL.createObjectURL(new Blob([res.data]))
            var fileLink = document.createElement('a')

            fileLink.href = fileUrl
            fileLink.setAttribute('download', 'resources.csv')
            document.body.appendChild(fileLink)
            fileLink.click()
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
}
</script>

<style scoped>
.img-profile {
  width: 24px;
  height: 24px;
}
</style>
